// File Metadata:
// Filename: RequireAuth.js
// Version: 1.00
// Created: 2022-09-28 21:44:25
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { useLocation, Navigate, Outlet } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

const RequireAuth = ({ allowedRoles }) => {
    const location = useLocation();
    const { roles } = useAuth();
    
    console.log('Current user roles:', roles);
    console.log('Required roles:', allowedRoles);

    // Check if user has any of the required roles
    const hasRequiredRole = Object.entries(allowedRoles).some(([role, required]) => {
        const hasRole = required && roles?.[role] === true;
        console.log(`Checking ${role}: required=${required}, hasRole=${hasRole}`);
        return hasRole;
    });

    if (!hasRequiredRole) {
        console.log('Access denied, redirecting to login');
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <Outlet />;
};

export default RequireAuth;
